import { environmentkeys } from "./environment-keys.prod";
const envType=environmentkeys.env;
const envPath=environmentkeys[envType];
export const environment = {
  production: true,
  env:envType,
  ...envPath
};
